import classnames from 'classnames/bind'
import React from 'react'
import { useTranslate } from 'react-polyglot'
import { GlobalGridPreset } from '~/@types/grid-preset'
import { GlobalTextPreset } from '~/@types/text-preset'

import Spinner from '~/components/Abstracts/Spinner'
import ProductCard, { ProductCardProps } from '~/components/UI/ProductCard'

import { useStyle } from '~/providers/StyleProvider'

import { PRODUCT } from '~/data/dictionary'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export type RecentlyViewedProductsGridProps = {
  className?: string
  items?: ProductCardProps[]
  hasUuidsToFetch: boolean
  isLoading: boolean
}

function RecentlyViewedProductsGrid({
  className,
  items,
  isLoading,
  hasUuidsToFetch,
}: RecentlyViewedProductsGridProps) {
  const t = useTranslate()
  const gridStyle = useStyle({ grid: GlobalGridPreset.BASE_GRID })
  const titleStyle = useStyle({
    textPreset: GlobalTextPreset.TitleFluid38_144SangBleu,
  })

  return (
    hasUuidsToFetch && (
      <div className={cx(css.RecentlyViewedProductsGrid, className)}>
        <div className={cx(css.top, gridStyle)}>
          <div className={cx(css.title, titleStyle)}>
            {t(PRODUCT.RECENTLY_VIEWED)}
          </div>
        </div>
        <div className={cx(css.body, gridStyle)}>
          {isLoading && (
            <div className={css.loadingPanel}>
              <Spinner className={css.spinner} />
            </div>
          )}
          {!isLoading &&
            items?.length > 0 &&
            items?.map((item, index) => (
              <ProductCard
                className={css.item}
                key={`card_recently_${index}`}
                {...item}
              />
            ))}
        </div>
      </div>
    )
  )
}

RecentlyViewedProductsGrid.defaultProps = {}

export default RecentlyViewedProductsGrid
